module.exports = __webpack_public_path__ + "static/media/ly.41489295.svg";